module.exports = __webpack_public_path__ + "img/1580740460.a6da9b3c.jpg";